export const COUNTER_SIZES = {
  SMALL: "small",
  BIG: "big",
  LARGE: "large",
};
